export default "__VITE_ASSET___LmJQZFN__"